var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaunchSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.3 175C34.7695 173.839 34.0684 171.825 34.0171 169.111C33.8974 162.026 34.7182 155.164 38.1891 148.865C45.1482 136.25 55.8689 129.609 70.3 129.046C72.8306 128.943 75.3783 129.046 78.0627 129.046C78.798 136.045 81.8928 141.678 87.672 145.69C91.7757 148.54 96.3923 149.787 101.385 149.496C112.072 148.865 121.151 140.466 122.108 129.182C146.217 126.536 161.76 140.978 165.248 158.356C166.068 162.47 165.915 166.789 166.017 171.023C166.068 173.037 164.512 174.147 162.854 175.017H37.3V175Z",
    fill: "url(#paint0_linear_106_352)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.967 73.3956C75.6006 73.3956 80.2856 73.3444 84.9706 73.3956C95.9307 73.5493 105.745 70.3912 114.329 63.5288C114.517 63.3752 114.722 63.2557 114.978 63.085C119.612 66.7893 124.229 70.4766 128.828 74.1809C129.119 74.4199 129.375 74.8979 129.375 75.2564C129.324 81.2994 129.375 87.3595 129.05 93.3854C128.914 95.9631 127.922 98.4725 127.306 101.033C130.333 101.033 133.547 101.323 136.693 100.948C140.181 100.538 142.507 97.4653 142.592 93.9487C142.609 92.9928 142.592 92.0198 142.592 90.9614H138.301V73.4981C140.233 73.4981 142.216 73.2591 144.097 73.5493C148.423 74.215 151.347 77.7828 151.381 82.1529C151.415 86.2499 151.466 90.3468 151.364 94.4438C151.176 102.057 145.431 108.851 137.856 109.603C132.419 110.149 126.879 109.705 121.595 109.705C123.34 107.127 125.186 104.362 127.238 101.306C126.332 101.238 125.938 101.17 125.528 101.17C118.193 101.17 110.875 101.17 103.54 101.17C100.581 101.17 98.581 102.979 98.6152 105.608C98.6323 108.169 100.633 109.944 103.488 109.961C108.72 109.961 113.952 109.961 119.167 109.961H120.912C120.399 110.49 120.125 110.849 119.783 111.139C110.841 118.752 100.718 120.92 89.7411 116.772C78.9006 112.675 72.369 104.533 71.1208 92.9757C70.4198 86.5742 71.0012 80.0361 71.0012 73.3615L70.967 73.3956Z",
    fill: "url(#paint1_linear_106_352)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.266 64.6043C135.873 64.6043 133.77 64.6555 131.666 64.5701C131.102 64.5531 130.47 64.2116 130.008 63.8532C126.024 60.7122 122.074 57.5199 118.09 54.3619C115.474 52.2792 113.508 52.3817 111.097 54.6691C104.104 61.2755 95.7768 64.5701 86.1675 64.6043C78.5928 64.6384 71.0182 64.6043 63.4436 64.6043C63.0162 64.6043 62.5716 64.6043 61.9048 64.6043C61.8364 51.3745 66.7607 40.62 77.2763 32.665C89.5358 23.3786 106.156 22.4397 119.304 30.3434C132.094 38.0252 138.078 49.6333 138.249 64.6043H138.266Z",
    fill: "url(#paint2_linear_106_352)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9198 125.256C95.6571 128.329 104.36 128.346 113.046 125.324C114.072 129.763 111.986 135.174 108.019 138.059C103.488 141.336 98.598 141.746 93.7079 139.049C88.3903 136.113 86.4923 131.282 86.9369 125.256H86.9198Z",
    fill: "url(#paint3_linear_106_352)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8704 73.5151V90.8248C57.3222 91.2004 53.1502 87.0351 53.1331 82.187C53.1331 77.339 57.2709 73.2079 61.8704 73.5151Z",
    fill: "url(#paint4_linear_106_352)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_352",
    x1: 100.012,
    y1: 128.868,
    x2: 100.012,
    y2: 175.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_106_352",
    x1: 111.1,
    y1: 63.085,
    x2: 111.1,
    y2: 118.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_106_352",
    x1: 100.085,
    y1: 25,
    x2: 100.085,
    y2: 64.6195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_106_352",
    x1: 100.09,
    y1: 125.256,
    x2: 100.09,
    y2: 140.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_106_352",
    x1: 57.5017,
    y1: 73.499,
    x2: 57.5017,
    y2: 90.8484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 150,
    fill: "white",
    transform: "translate(34 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchSupport);
export default __webpack_public_path__ + "static/media/Launch_Support.670e189b83a3e8928306c0be8ba4a645.svg";
export { ForwardRef as ReactComponent };